<template>
  <div class="new-feature__badge">
    <div class="sr-only">An icon drawing attention to a new feature</div>
    <div class="new-feature__pulse new-feature__pulse-1"></div>
    <div class="new-feature__pulse new-feature__pulse-2"></div>
    <div class="new-feature__pulse new-feature__pulse-3"></div>
    <div class="new-feature__pulse new-feature__pulse-4"></div>
  </div>
</template>

<style lang="scss">
  .new-feature__badge {
    background: variables.$primitives-color-green-200;
    border-radius: 50%;
    height: variables.$sizing-xs;
    position: absolute;
    right: - calc(variables.$sizing-xs / 2);
    top: - calc(variables.$sizing-xs / 2);
    width: variables.$sizing-xs;
    z-index: 10;
  }

  .new-feature__pulse {
    animation: newFeaturePulseWave 4s infinite cubic-bezier(.36, .11, .89, .32);
    border: solid 2px variables.$primitives-color-green-200;
    border-radius: 50%;
    height: variables.$sizing-xxl;
    left: -(variables.$sizing-xs);
    opacity: 0;
    position: absolute;
    top: -(variables.$sizing-xs);
    width: variables.$sizing-xxl;
  }

  .new-feature__pulse-1 { animation-delay: 0s; }
  .new-feature__pulse-2 { animation-delay: 1s; }
  .new-feature__pulse-3 { animation-delay: 2s; }
  .new-feature__pulse-4 { animation-delay: 3s; }

  @keyframes newFeaturePulseWave {
    from {
      opacity: 0.5;
      transform: scale(0.1);
    }
    to {
      opacity: 0;
      transform: scale(1);
    }
  }
</style>
